<script>
export default {
  name: 'IntelligenceV2SugestoesDeExemplo',
  props: {
    // `[{ text, icon, titulo?, descricao? }]` — mesmo payload base do
    // `SuggestionChips`. `text` é a frase INTEIRA (o que é enviado ao
    // clicar); `titulo` é o rótulo curto exibido em negrito — sem ele, cai
    // no próprio `text` (compatibilidade com quem só manda `{text, icon}`).
    sugestoes: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
  computed: {
    itens() {
      return this.sugestoes.map(function (sugestao, indice) {
        return {
          chave: sugestao.text + '-' + indice,
          prompt: sugestao.text,
          titulo: sugestao.titulo || sugestao.text,
          descricao: sugestao.descricao || '',
          icone: sugestao.icon,
        }
      })
    },
    temItens() {
      return this.itens.length > 0
    },
  },
  methods: {
    usar(prompt) {
      this.$emit('use', prompt)
    },
  },
}
</script>

<template>
  <div v-if="temItens" class="sugestoes-de-exemplo">
    <button
      v-for="item in itens"
      :key="item.chave"
      type="button"
      class="sugestoes-de-exemplo__linha"
      @click="usar(item.prompt)"
    >
      <icon-svg
        :name="item.icone"
        :size="15"
        color="currentColor"
        class="sugestoes-de-exemplo__icone"
      />
      <span class="sugestoes-de-exemplo__titulo ia-texto-corpo">{{ item.titulo }}</span>
      <span
        v-if="item.descricao"
        class="sugestoes-de-exemplo__descricao ia-texto-auxiliar"
      >{{ item.descricao }}</span>
    </button>
  </div>
</template>

<style lang="sass" scoped>
// Lista vertical, uma sugestão por linha — estilo ChatGPT (ícone + texto,
// sem cartão, sem grade). Tipografia e cores copiadas BYTE A BYTE de
// `.acoes-modulo__linha*` (acoes-por-modulo.vue, layout `lista` do menu do
// "+"/`/crm"`) — pedido explícito do usuário: as duas listas de sugestão do
// estado vazio devem ler como a MESMA família visual.
.sugestoes-de-exemplo
  display: flex
  flex-direction: column
  width: 100%

// [feedback do usuário] "vamos fazer igual o chat gpt... os itens estão com
// menos opacidade e ao passar o mouse eles ficam 100%" — no ChatGPT real a
// linha em repouso é esmaecida (ícone + texto juntos, via `opacity` no
// próprio botão) e só acende 100% no hover/foco, junto com o destaque de
// fundo. `opacity` no botão inteiro (não uma cor por elemento) porque é o
// que atinge ícone e texto de uma vez só, sem duplicar a régua de esmaecer
// em dois lugares.
.sugestoes-de-exemplo__linha
  display: flex
  // `baseline` e não `center`: título e descrição na mesma linha, assentados
  // pela linha de base do texto — mesma receita de `.acoes-modulo__linha`.
  align-items: baseline
  gap: 12px
  width: 100%
  padding: 12px 14px
  border: 0
  background: none
  border-radius: 12px
  text-align: left
  cursor: pointer
  opacity: 0.6
  transition: opacity var(--motion-duration-fast) var(--motion-easing-standard), background var(--motion-duration-fast) var(--motion-easing-standard)

  &:hover,
  &:focus
    opacity: 1
    background: var(--neutral-100)

.sugestoes-de-exemplo__icone
  flex-shrink: 0
  // Ícone alinha pelo TOPO do texto (a linha inteira usa `baseline`) — mesma
  // regra de `.acoes-modulo__linha-icone`.
  align-self: center
  color: var(--neutral-400)

// Título nunca encolhe nem quebra — é o que se procura na lista; quem cede
// espaço é a descrição. Mesma régua de `.acoes-modulo__linha-titulo`.
.sugestoes-de-exemplo__titulo
  color: var(--neutral-900)
  flex-shrink: 0
  white-space: nowrap

.sugestoes-de-exemplo__descricao
  color: var(--neutral-600)
  flex: 1 1 auto
  min-width: 0
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
</style>
